<ra-modal
    #mainModal
    [title]="'document.edit.headerEditor.title' | translate"
    [size]="'xlarge'"
    [animation]="'slide-right'"
    [backdrop]="false"
    (close)="close.emit()"
>
    <div class="header-twopane">
        <!-- Esquerda: campos -->
        <div class="pane-fields">
            <div class="pane-head">
                <span class="pane-title">{{ 'document.edit.headerEditor.fieldsTitle' | translate }}</span>
                <span class="header-badge">
                    {{ 'document.edit.headerEditor.countBadge' | translate: { count: visibleCount(), max: MAX_VISIBLE } }}
                </span>
            </div>

            <div class="header-items">
                @for (item of editableItems(); track item.fieldId) {
                    @if (item.type === IMAGE) {
                        <!-- Logo -->
                        <div class="header-card is-visible">
                            <div class="header-card-head">
                                <div class="header-card-icon active">
                                    <ra-icon [icon]="iconFor(item)" varColor="accentBlue" [size]="20" />
                                </div>
                                <div class="header-card-text">
                                    <span class="header-card-title">{{ titleFor(item) }}</span>
                                    <span class="header-card-desc">{{ descFor(item) }}</span>
                                </div>
                            </div>

                            <div class="header-card-input logo-row">
                                <div class="logo-thumb">
                                    @if (logoUrl(item)) {
                                        <img [src]="logoUrl(item)" alt="logo" />
                                    } @else {
                                        <ra-icon icon="gallery" varColor="contentTertiary" [size]="20" />
                                    }
                                </div>

                                <div class="logo-actions">
                                    <button
                                        type="button"
                                        class="logo-btn"
                                        [class.selected]="isUsingCompanyLogo(item)"
                                        (click)="useCompanyLogo(item)"
                                    >
                                        {{ 'document.edit.headerEditor.useCompanyLogo' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="logo-btn"
                                        [disabled]="logoUploading()"
                                        (click)="uploadLogo(item)"
                                    >
                                        {{ (logoUploading() ? 'document.edit.headerEditor.uploading' : 'document.edit.headerEditor.uploadImage') | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <!-- Campo de texto -->
                        <div class="header-card" [class.is-visible]="item.isVisible">
                            <div class="header-card-head" (click)="onCardHeadClick(item)">
                                <div class="header-card-icon" [class.active]="item.isVisible">
                                    <ra-icon
                                        [icon]="iconFor(item)"
                                        [varColor]="item.isVisible ? 'accentBlue' : 'contentSecondary'"
                                        [size]="20"
                                    />
                                </div>

                                <div class="header-card-text">
                                    <span class="header-card-title">{{ titleFor(item) }}</span>
                                    <span class="header-card-desc">{{ descFor(item) }}</span>
                                </div>

                                @if (item.canHide && controlFor(item.fieldId)) {
                                    <ra-switch [formControl]="controlFor(item.fieldId)" />
                                }
                            </div>

                            @if (item.isVisible) {
                                <div class="header-card-input">
                                    <ra-link-token-composer
                                        [text]="textValue(item)"
                                        [linkTagName]="linkTagNameOf(item)"
                                        [limitChar]="limitCharOf(item)"
                                        [placeholder]="'document.edit.headerEditor.inputPlaceholder' | translate"
                                        (valueChange)="onComposerChange(item.fieldId, $event)"
                                    />
                                </div>
                            }
                        </div>
                    }
                }
            </div>
        </div>

        <!-- Direita: pré-visualização + salvar -->
        <div class="pane-preview">
            <span class="pane-title">{{ 'document.edit.headerEditor.previewTitle' | translate }}</span>

            <div class="preview-sheet">
                <div class="preview-header">
                    <div class="preview-logo">
                        @if (previewLogo()) {
                            <img [src]="previewLogo()" alt="logo" />
                        }
                    </div>

                    @if (previewTexts().length) {
                        <div class="preview-header-texts">
                            @for (t of previewTexts(); track $index) {
                                <span class="preview-header-text" [class.first]="$first">{{ t }}</span>
                            }
                        </div>
                    }
                </div>

                <div class="preview-skeleton">
                    <span class="sk-line"></span>
                    <span class="sk-line"></span>
                    <span class="sk-line short"></span>
                </div>
            </div>

            <div class="pane-foot">
                <ra-button
                    [label]="'common.save' | translate"
                    [type]="'primary'"
                    [loading]="loading()"
                    [disabled]="!canAct()"
                    (click)="confirmSave()"
                />
            </div>
        </div>
    </div>
</ra-modal>
